import { createFrontOfficeInstance } from '@/shared/api/api-instance';

import type {
  AiDelayedDeliveriesQueryDto,
  AiDelayedDeliveriesResponseDto,
  AiDelayedDeliveryDto,
  AiDelayedDeliveryDetailDto,
  AiDelayedDeliveryStatus,
  AiFeedbackDto,
  AiTraceDeliveryStateDto,
  AiTraceDetailDto,
  AiTraceKnowledgeBaseSourceDto,
  AiTraceListItemDto,
  AiTraceMode,
  AiTraceReasonCode,
  AiTracesQueryDto,
  AiTracesResponseDto,
  AiTraceStatus,
  AiTraceUsageDto,
} from '@gochat/ai-types';

export type AiTraceModeDto = AiTraceMode;
export type AiTraceStatusDto = AiTraceStatus;
export type AiTraceReasonCodeDto = AiTraceReasonCode;
export type {
  AiDelayedDeliveriesQueryDto,
  AiDelayedDeliveriesResponseDto,
  AiDelayedDeliveryDto,
  AiDelayedDeliveryDetailDto,
  AiTraceDeliveryStateDto,
  AiTraceDetailDto,
  AiTraceKnowledgeBaseSourceDto,
  AiTraceListItemDto,
  AiTraceUsageDto,
};
export type { AiFeedbackDto };
export type AiDelayedDeliveryStatusDto = AiDelayedDeliveryStatus;
export type AiTraceFiltersDto = Omit<AiTracesQueryDto, 'limit'> & {
  limit?: number;
};
export type AiTraceListResponseDto = AiTracesResponseDto;
export type AiDelayedDeliveryFiltersDto = Omit<
  AiDelayedDeliveriesQueryDto,
  'limit'
> & {
  limit?: number;
};

function compactParams(filters: Record<string, string | number | undefined>) {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === '') return;
    params.set(key, String(value));
  });

  return params.toString();
}

export const getAiTraces = (filters: AiTraceFiltersDto = {}) => {
  const query = compactParams(filters);

  return createFrontOfficeInstance<AiTraceListResponseDto>({
    url: `/api/v1/ai/traces${query ? `?${query}` : ''}`,
    method: 'GET',
  });
};

export const getAiTrace = (id: string) =>
  createFrontOfficeInstance<AiTraceDetailDto>({
    url: `/api/v1/ai/traces/${id}`,
    method: 'GET',
  });

export const getAiDelayedDelivery = (id: string) =>
  createFrontOfficeInstance<AiDelayedDeliveryDetailDto>({
    url: `/api/v1/ai/delayed-deliveries/${id}`,
    method: 'GET',
  });

export const getAiDelayedDeliveries = (
  filters: AiDelayedDeliveryFiltersDto = {}
) => {
  const query = compactParams(filters);

  return createFrontOfficeInstance<AiDelayedDeliveriesResponseDto>({
    url: `/api/v1/ai/delayed-deliveries${query ? `?${query}` : ''}`,
    method: 'GET',
  });
};

export const sendAiDelayedDeliveryNow = (id: string) =>
  createFrontOfficeInstance<AiDelayedDeliveryDetailDto>({
    url: `/api/v1/ai/delayed-deliveries/${id}/send-now`,
    method: 'POST',
  });

export const cancelAiDelayedDelivery = (id: string) =>
  createFrontOfficeInstance<AiDelayedDeliveryDetailDto>({
    url: `/api/v1/ai/delayed-deliveries/${id}/cancel`,
    method: 'POST',
  });

export const createAiTraceFeedback = (dto: AiFeedbackDto) =>
  createFrontOfficeInstance<{ id: string }>({
    url: '/api/v1/ai/feedback',
    method: 'POST',
    data: dto,
  });

export const createAiFeedback = createAiTraceFeedback;
